import * as API from "middleware/api";

export const searchCompany = (params) => API.executeWithAccessToken("/rapipago.company.search", { ...params });
export const searchPaymentModes = (params) => API.executeWithAccessToken("/rapipago.mode.search", { ...params });
export const searchBilling = (params) => API.executeWithAccessToken("/rapipago.billing.search", { ...params });
export const billPrepare = (params) => API.executeWithAccessToken("/rapipago.bill.prepare", { ...params });
export const payService = (params) => API.executeWithAccessToken("/rapipago.operation.confirm", { ...params });
export const rapipagoVoucher = (params) => API.executeWithAccessToken("/rapipago.voucher", { ...params });
export const getDebts = () => API.executeWithAccessToken("/rapipago.read.debt");
export const getScheduledBill = (params) =>
    API.executeWithAccessToken("/rapipago.billing.schedule.search", { ...params });
